import {getReportParams, report} from '../../../middleware/report';

export function dwhLead(status,messageText, isAgreementsCheckBoxActive,leadSubject, name , phoneNumber ) {
  let reportParams = getReportParams();
  reportParams.subscriber = phoneNumber,
  reportParams.area = 'MarketingPages';
  reportParams.subArea = 'LeadBlocks';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Short Lead Block';
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.param1 = isAgreementsCheckBoxActive;
  reportParams.param2 = leadSubject;
  reportParams.param3 = name;
  reportParams.param4 = phoneNumber;
  report(reportParams);
}

